import MarginCalculatorPresenter from "@adapters/features/Tools/MarginCalculator/Presenters/MarginCalculator";
export default (useCases, actions) => {
    return {
        marginCalculator: new MarginCalculatorPresenter(useCases.marginCalculator, actions.marginCalculator),
    };
};
